import React, { Component } from 'react';
import './App.css';
import firebase, { auth, provider } from './firebase.js';

class App extends Component {
  constructor() {
    super();
    this.state = {
      currentItem: '',
      currentNeed: '',
      username: '',
      items: [],
      needs: [],
      user: null,
      searchItem: '',
      searchNeed: ''
    }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }
  handleChange2 = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  notBlank(x) {
    if (x === "") {
      alert("Must not be blank");
      return false;
    }
    return true
  }

  validateForm() {
    var x = document.forms["addItem"]["currentItem"].value;
    var valididty = this.notBlank(x)
    if (!valididty) {
      return false
    }
    return true
  }
  validateForm2() {
    var x = document.forms["addNeed"]["currentNeed"].value;
    var valididty = this.notBlank(x)
    if (!valididty) {
      return false
    }
    return true
  }

  handleSubmit = (e) => {
    e.preventDefault(); // default form submission requires full page refresh
    const itemsRef = firebase.database().ref('items');
    var validity = this.validateForm()
    if(validity) {
      const item = {
        title: this.state.currentItem, // or // user: this.state.username,
        user: this.state.user.displayName || this.state.user.email,
      }
      itemsRef.push(item);
      this.setState({
        currentItem: '',
        username: ''
      });
    }
  }
  handleSubmit2 = (e) => {
    e.preventDefault();
    const needsRef = firebase.database().ref('needs');
    var validity = this.validateForm2()
    if(validity) {
      const need = {
        title: this.state.currentNeed,
        user: this.state.user.displayName || this.state.user.email,
      }
      needsRef.push(need);
      this.setState({
        currentNeed: '',
        username: ''
      });
    }
  }

  persistLoginWhenRefreshingPage() {
    auth.onAuthStateChanged((user) => {
      if (user) {
        this.setState({ user });
      }
    });
  }

  // currently: go to items db, grab snapshot of current db values for items and
  // push the new state for id title and user
  // while setting this new pushed state
  loadData() {
    const itemsRef = firebase.database().ref('items');
    itemsRef.on('value', (snapshot) => {
      let items = snapshot.val();
      let newState = [];
      for (let item in items) {
        newState.push({
          id: item,
          title: items[item].title,
          user: items[item].user
        });
      }
      this.setState({
        items: newState
      });
    });

    const needsRef = firebase.database().ref('needs');
    needsRef.on('value', (snapshot) => {
      let needs = snapshot.val();
      let newState = [];
      for (let need in needs) {
        newState.push({
          id: need,
          title: needs[need].title,
          user: needs[need].user
        });
      }
      this.setState({
        needs: newState
      });
    });
  }

  componentDidMount() {
    this.persistLoginWhenRefreshingPage()
    this.loadData() // added to load in items when logging in
  }

  // signInWithPopup has promise API .then and callback, provided with result object which containes several properies including .user, which we setState
  login = () => {
    auth.signInWithPopup(provider)
      .then((result) => {
        const user = result.user;
        this.setState({
          user
        });
        this.loadData() // added to load in items when logging in
      });

  }

  // clear state
  logout = () => {
    auth.signOut()
      .then(() => {
        this.setState({
          user: null,
          items: [],
          needs: [],
        });
      });
  }

  removeItem(itemId) {
    const itemRef = firebase.database().ref(`/items/${itemId}`);
    itemRef.remove();
  }
  removeNeed(needId) {
    const needRef = firebase.database().ref(`/needs/${needId}`);
    needRef.remove();
  }

  updateSearchItem = (event) => {
    this.setState({searchItem: event.target.value.substr(0,20)})
  }
  updateSearchNeed = (event) => {
    this.setState({searchNeed: event.target.value.substr(0,20)})
  }

  render() {
    let filteredItems = this.state.items.filter(
      (item) => {
        // if you cannot find within this context then do not return, else do
        return item.title.toLowerCase()
          .indexOf(this.state.searchItem.toLowerCase()) !== -1
      }
    )
    // console.log(filteredItems)

    let filteredNeeds = this.state.needs.filter(
      (need) => {
        return need.title.toLowerCase()
          .indexOf(this.state.searchNeed.toLowerCase()) !== -1
      }
    )
    // console.log(filteredNeeds)

    return (
      <div className='app'>
        <header>
          <div className="wrapper">
            <h1>GyftSpace</h1>
            {/* Show User's Photo if Logged In, OR Prompt User to Log In */}
            {this.state.user ?
              <button className="logButtons" onClick={this.logout}>
                <div className='userProfile'>
                  Log Out
                  <img src={this.state.user.photoURL} alt='no img available'
                      className="mainProfilePic"/>
                </div>
              </button>
              :
              <button className="logButtons" onClick={this.login}>
                Log In
                {/* <p>Must be logged in to see submissions.</p> */}
              </button>
            }
          </div>
        </header>

        <div className='row'>
          <section className='menu'>
            <form name="searchItemForm">
                <input type="text" value={this.state.searchItem}
                       onChange={this.updateSearchItem} id="searchItem" placeholder="Search Item?" className="menuInput"/>
            </form>
            <div className="spacer"></div>
            <form onSubmit={this.handleSubmit} name="addItem">
              <input type="text" name="currentItem" className="menuInput"
                     placeholder="I Will Bring?" onChange={this.handleChange} value={this.state.currentItem} />
            </form>
          </section>

          <section className='menu'>
            <form name="searchNeedForm">
              <input type="text" value={this.state.searchNeed}
                     onChange={this.updateSearchNeed} id="searchNeed" placeholder="Search Need?" className="menuInput"/>
            </form>
            <div className="spacer"></div>
            <form onSubmit={this.handleSubmit2} name="addNeed">
              <input type="text" name="currentNeed" className="menuInput"
                     placeholder="We Need Item?" onChange={this.handleChange2} value={this.state.currentNeed} />
            </form>
          </section>
        </div>

        <div className='row'>
          <section className='items'>
            <p className="title">Provided</p>
            <ul>
              {filteredItems.map((item) => {
                return (
                  <li key={item.id} className='item'>
                    <div className='itemHeader'>
                      <button className="deleteButton"
                              onClick={() => this.removeItem(item.id)}>
                        X
                      </button>
                      <h3>{item.title}</h3>
                    </div>
                    <div className='itemFooter'>
                        <small>by: {item.user}</small>
                        <img src={this.state.user.photoURL}
                             alt='no img available' className="avatar"/>
                    </div>
                  </li>
                )
              })}
            </ul>
          </section>

          <section className='needs'>
            <div className="wrapper">
              <p className="title">Requested</p>
              <ul>
                {filteredNeeds.map((need) => {
                  return (
                    <li key={need.id} className='need'>
                      <div className='needHeader'>
                        <button className="deleteButton"
                                onClick={() => this.removeNeed(need.id)}>
                          X
                        </button>
                        <h3>{need.title}</h3>
                      </div>
                      <div className='needFooter'>
                          <small>by: {need.user}</small>
                          <img src={this.state.user.photoURL}
                               alt='no img available' className="avatar"/>
                      </div>
                    </li>
                  )
                })}
              </ul>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js